// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v5.29.3
// source: taf_action.proto
/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { GT12_Schedule } from "./gt12";
import { VastAds, VastPlaylist } from "./vast";
export const protobufPackage = "taf";
export var TafAction_SetVariant_Variant;
(function (TafAction_SetVariant_Variant) {
    TafAction_SetVariant_Variant[TafAction_SetVariant_Variant["STREAMING_HUB"] = 0] = "STREAMING_HUB";
    TafAction_SetVariant_Variant[TafAction_SetVariant_Variant["ZAPI"] = 1] = "ZAPI";
    TafAction_SetVariant_Variant[TafAction_SetVariant_Variant["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TafAction_SetVariant_Variant || (TafAction_SetVariant_Variant = {}));
export function tafAction_SetVariant_VariantFromJSON(object) {
    switch (object) {
        case 0:
        case "STREAMING_HUB":
            return TafAction_SetVariant_Variant.STREAMING_HUB;
        case 1:
        case "ZAPI":
            return TafAction_SetVariant_Variant.ZAPI;
        case -1:
        case "UNRECOGNIZED":
        default:
            return TafAction_SetVariant_Variant.UNRECOGNIZED;
    }
}
export function tafAction_SetVariant_VariantToJSON(object) {
    switch (object) {
        case TafAction_SetVariant_Variant.STREAMING_HUB:
            return "STREAMING_HUB";
        case TafAction_SetVariant_Variant.ZAPI:
            return "ZAPI";
        case TafAction_SetVariant_Variant.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
export var TafAction_ConfigureZapiMockedProxy_TimeshiftMode;
(function (TafAction_ConfigureZapiMockedProxy_TimeshiftMode) {
    TafAction_ConfigureZapiMockedProxy_TimeshiftMode[TafAction_ConfigureZapiMockedProxy_TimeshiftMode["AVAILABLE"] = 0] = "AVAILABLE";
    TafAction_ConfigureZapiMockedProxy_TimeshiftMode[TafAction_ConfigureZapiMockedProxy_TimeshiftMode["UNAVAILABLE"] = 1] = "UNAVAILABLE";
    TafAction_ConfigureZapiMockedProxy_TimeshiftMode[TafAction_ConfigureZapiMockedProxy_TimeshiftMode["ELIGIBLE"] = 2] = "ELIGIBLE";
    TafAction_ConfigureZapiMockedProxy_TimeshiftMode[TafAction_ConfigureZapiMockedProxy_TimeshiftMode["SUBSCRIBABLE"] = 3] = "SUBSCRIBABLE";
    TafAction_ConfigureZapiMockedProxy_TimeshiftMode[TafAction_ConfigureZapiMockedProxy_TimeshiftMode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TafAction_ConfigureZapiMockedProxy_TimeshiftMode || (TafAction_ConfigureZapiMockedProxy_TimeshiftMode = {}));
export function tafAction_ConfigureZapiMockedProxy_TimeshiftModeFromJSON(object) {
    switch (object) {
        case 0:
        case "AVAILABLE":
            return TafAction_ConfigureZapiMockedProxy_TimeshiftMode.AVAILABLE;
        case 1:
        case "UNAVAILABLE":
            return TafAction_ConfigureZapiMockedProxy_TimeshiftMode.UNAVAILABLE;
        case 2:
        case "ELIGIBLE":
            return TafAction_ConfigureZapiMockedProxy_TimeshiftMode.ELIGIBLE;
        case 3:
        case "SUBSCRIBABLE":
            return TafAction_ConfigureZapiMockedProxy_TimeshiftMode.SUBSCRIBABLE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return TafAction_ConfigureZapiMockedProxy_TimeshiftMode.UNRECOGNIZED;
    }
}
export function tafAction_ConfigureZapiMockedProxy_TimeshiftModeToJSON(object) {
    switch (object) {
        case TafAction_ConfigureZapiMockedProxy_TimeshiftMode.AVAILABLE:
            return "AVAILABLE";
        case TafAction_ConfigureZapiMockedProxy_TimeshiftMode.UNAVAILABLE:
            return "UNAVAILABLE";
        case TafAction_ConfigureZapiMockedProxy_TimeshiftMode.ELIGIBLE:
            return "ELIGIBLE";
        case TafAction_ConfigureZapiMockedProxy_TimeshiftMode.SUBSCRIBABLE:
            return "SUBSCRIBABLE";
        case TafAction_ConfigureZapiMockedProxy_TimeshiftMode.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
export var TafAction_ConfigureZapiMockedProxy_Quality;
(function (TafAction_ConfigureZapiMockedProxy_Quality) {
    TafAction_ConfigureZapiMockedProxy_Quality[TafAction_ConfigureZapiMockedProxy_Quality["SD"] = 0] = "SD";
    TafAction_ConfigureZapiMockedProxy_Quality[TafAction_ConfigureZapiMockedProxy_Quality["HD"] = 1] = "HD";
    TafAction_ConfigureZapiMockedProxy_Quality[TafAction_ConfigureZapiMockedProxy_Quality["UHD"] = 2] = "UHD";
    TafAction_ConfigureZapiMockedProxy_Quality[TafAction_ConfigureZapiMockedProxy_Quality["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TafAction_ConfigureZapiMockedProxy_Quality || (TafAction_ConfigureZapiMockedProxy_Quality = {}));
export function tafAction_ConfigureZapiMockedProxy_QualityFromJSON(object) {
    switch (object) {
        case 0:
        case "SD":
            return TafAction_ConfigureZapiMockedProxy_Quality.SD;
        case 1:
        case "HD":
            return TafAction_ConfigureZapiMockedProxy_Quality.HD;
        case 2:
        case "UHD":
            return TafAction_ConfigureZapiMockedProxy_Quality.UHD;
        case -1:
        case "UNRECOGNIZED":
        default:
            return TafAction_ConfigureZapiMockedProxy_Quality.UNRECOGNIZED;
    }
}
export function tafAction_ConfigureZapiMockedProxy_QualityToJSON(object) {
    switch (object) {
        case TafAction_ConfigureZapiMockedProxy_Quality.SD:
            return "SD";
        case TafAction_ConfigureZapiMockedProxy_Quality.HD:
            return "HD";
        case TafAction_ConfigureZapiMockedProxy_Quality.UHD:
            return "UHD";
        case TafAction_ConfigureZapiMockedProxy_Quality.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
export var TafAction_ConfigureZapiMockedProxy_Stream_Ad_Type;
(function (TafAction_ConfigureZapiMockedProxy_Stream_Ad_Type) {
    TafAction_ConfigureZapiMockedProxy_Stream_Ad_Type[TafAction_ConfigureZapiMockedProxy_Stream_Ad_Type["bcff"] = 0] = "bcff";
    TafAction_ConfigureZapiMockedProxy_Stream_Ad_Type[TafAction_ConfigureZapiMockedProxy_Stream_Ad_Type["midroll"] = 1] = "midroll";
    TafAction_ConfigureZapiMockedProxy_Stream_Ad_Type[TafAction_ConfigureZapiMockedProxy_Stream_Ad_Type["pause"] = 2] = "pause";
    TafAction_ConfigureZapiMockedProxy_Stream_Ad_Type[TafAction_ConfigureZapiMockedProxy_Stream_Ad_Type["preroll"] = 3] = "preroll";
    TafAction_ConfigureZapiMockedProxy_Stream_Ad_Type[TafAction_ConfigureZapiMockedProxy_Stream_Ad_Type["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TafAction_ConfigureZapiMockedProxy_Stream_Ad_Type || (TafAction_ConfigureZapiMockedProxy_Stream_Ad_Type = {}));
export function tafAction_ConfigureZapiMockedProxy_Stream_Ad_TypeFromJSON(object) {
    switch (object) {
        case 0:
        case "bcff":
            return TafAction_ConfigureZapiMockedProxy_Stream_Ad_Type.bcff;
        case 1:
        case "midroll":
            return TafAction_ConfigureZapiMockedProxy_Stream_Ad_Type.midroll;
        case 2:
        case "pause":
            return TafAction_ConfigureZapiMockedProxy_Stream_Ad_Type.pause;
        case 3:
        case "preroll":
            return TafAction_ConfigureZapiMockedProxy_Stream_Ad_Type.preroll;
        case -1:
        case "UNRECOGNIZED":
        default:
            return TafAction_ConfigureZapiMockedProxy_Stream_Ad_Type.UNRECOGNIZED;
    }
}
export function tafAction_ConfigureZapiMockedProxy_Stream_Ad_TypeToJSON(object) {
    switch (object) {
        case TafAction_ConfigureZapiMockedProxy_Stream_Ad_Type.bcff:
            return "bcff";
        case TafAction_ConfigureZapiMockedProxy_Stream_Ad_Type.midroll:
            return "midroll";
        case TafAction_ConfigureZapiMockedProxy_Stream_Ad_Type.pause:
            return "pause";
        case TafAction_ConfigureZapiMockedProxy_Stream_Ad_Type.preroll:
            return "preroll";
        case TafAction_ConfigureZapiMockedProxy_Stream_Ad_Type.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
export var TafAction_ConfigureStreamingHubProxy_License_Valid_Scope;
(function (TafAction_ConfigureStreamingHubProxy_License_Valid_Scope) {
    TafAction_ConfigureStreamingHubProxy_License_Valid_Scope[TafAction_ConfigureStreamingHubProxy_License_Valid_Scope["PLAYBACK_SDK"] = 0] = "PLAYBACK_SDK";
    TafAction_ConfigureStreamingHubProxy_License_Valid_Scope[TafAction_ConfigureStreamingHubProxy_License_Valid_Scope["TELEMETRY"] = 1] = "TELEMETRY";
    TafAction_ConfigureStreamingHubProxy_License_Valid_Scope[TafAction_ConfigureStreamingHubProxy_License_Valid_Scope["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TafAction_ConfigureStreamingHubProxy_License_Valid_Scope || (TafAction_ConfigureStreamingHubProxy_License_Valid_Scope = {}));
export function tafAction_ConfigureStreamingHubProxy_License_Valid_ScopeFromJSON(object) {
    switch (object) {
        case 0:
        case "PLAYBACK_SDK":
            return TafAction_ConfigureStreamingHubProxy_License_Valid_Scope.PLAYBACK_SDK;
        case 1:
        case "TELEMETRY":
            return TafAction_ConfigureStreamingHubProxy_License_Valid_Scope.TELEMETRY;
        case -1:
        case "UNRECOGNIZED":
        default:
            return TafAction_ConfigureStreamingHubProxy_License_Valid_Scope.UNRECOGNIZED;
    }
}
export function tafAction_ConfigureStreamingHubProxy_License_Valid_ScopeToJSON(object) {
    switch (object) {
        case TafAction_ConfigureStreamingHubProxy_License_Valid_Scope.PLAYBACK_SDK:
            return "PLAYBACK_SDK";
        case TafAction_ConfigureStreamingHubProxy_License_Valid_Scope.TELEMETRY:
            return "TELEMETRY";
        case TafAction_ConfigureStreamingHubProxy_License_Valid_Scope.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
export var TafAction_ConfigureVast_Source;
(function (TafAction_ConfigureVast_Source) {
    TafAction_ConfigureVast_Source[TafAction_ConfigureVast_Source["LOCAL"] = 0] = "LOCAL";
    TafAction_ConfigureVast_Source[TafAction_ConfigureVast_Source["REMOTE"] = 1] = "REMOTE";
    TafAction_ConfigureVast_Source[TafAction_ConfigureVast_Source["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TafAction_ConfigureVast_Source || (TafAction_ConfigureVast_Source = {}));
export function tafAction_ConfigureVast_SourceFromJSON(object) {
    switch (object) {
        case 0:
        case "LOCAL":
            return TafAction_ConfigureVast_Source.LOCAL;
        case 1:
        case "REMOTE":
            return TafAction_ConfigureVast_Source.REMOTE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return TafAction_ConfigureVast_Source.UNRECOGNIZED;
    }
}
export function tafAction_ConfigureVast_SourceToJSON(object) {
    switch (object) {
        case TafAction_ConfigureVast_Source.LOCAL:
            return "LOCAL";
        case TafAction_ConfigureVast_Source.REMOTE:
            return "REMOTE";
        case TafAction_ConfigureVast_Source.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseTafAction() {
    return {
        sleep: undefined,
        setVariant: undefined,
        setupZapiProxy: undefined,
        setupZapiMockedProxy: undefined,
        configureZapiMockedProxy: undefined,
        startSession: undefined,
        configureStreamingHubProxy: undefined,
        configureVast: undefined,
        cleanupSession: undefined,
    };
}
export const TafAction = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.sleep !== undefined) {
            TafAction_Sleep.encode(message.sleep, writer.uint32(10).fork()).ldelim();
        }
        if (message.setVariant !== undefined) {
            TafAction_SetVariant.encode(message.setVariant, writer.uint32(18).fork()).ldelim();
        }
        if (message.setupZapiProxy !== undefined) {
            TafAction_SetupZapiProxy.encode(message.setupZapiProxy, writer.uint32(26).fork()).ldelim();
        }
        if (message.setupZapiMockedProxy !== undefined) {
            TafAction_SetupZapiMockedProxy.encode(message.setupZapiMockedProxy, writer.uint32(34).fork()).ldelim();
        }
        if (message.configureZapiMockedProxy !== undefined) {
            TafAction_ConfigureZapiMockedProxy.encode(message.configureZapiMockedProxy, writer.uint32(42).fork()).ldelim();
        }
        if (message.startSession !== undefined) {
            TafAction_StartSession.encode(message.startSession, writer.uint32(50).fork()).ldelim();
        }
        if (message.configureStreamingHubProxy !== undefined) {
            TafAction_ConfigureStreamingHubProxy.encode(message.configureStreamingHubProxy, writer.uint32(58).fork())
                .ldelim();
        }
        if (message.configureVast !== undefined) {
            TafAction_ConfigureVast.encode(message.configureVast, writer.uint32(66).fork()).ldelim();
        }
        if (message.cleanupSession !== undefined) {
            TafAction_CleanupSession.encode(message.cleanupSession, writer.uint32(74).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.sleep = TafAction_Sleep.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.setVariant = TafAction_SetVariant.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.setupZapiProxy = TafAction_SetupZapiProxy.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.setupZapiMockedProxy = TafAction_SetupZapiMockedProxy.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.configureZapiMockedProxy = TafAction_ConfigureZapiMockedProxy.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.startSession = TafAction_StartSession.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.configureStreamingHubProxy = TafAction_ConfigureStreamingHubProxy.decode(reader, reader.uint32());
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.configureVast = TafAction_ConfigureVast.decode(reader, reader.uint32());
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.cleanupSession = TafAction_CleanupSession.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            sleep: isSet(object.sleep) ? TafAction_Sleep.fromJSON(object.sleep) : undefined,
            setVariant: isSet(object.setVariant) ? TafAction_SetVariant.fromJSON(object.setVariant) : undefined,
            setupZapiProxy: isSet(object.setupZapiProxy)
                ? TafAction_SetupZapiProxy.fromJSON(object.setupZapiProxy)
                : undefined,
            setupZapiMockedProxy: isSet(object.setupZapiMockedProxy)
                ? TafAction_SetupZapiMockedProxy.fromJSON(object.setupZapiMockedProxy)
                : undefined,
            configureZapiMockedProxy: isSet(object.configureZapiMockedProxy)
                ? TafAction_ConfigureZapiMockedProxy.fromJSON(object.configureZapiMockedProxy)
                : undefined,
            startSession: isSet(object.startSession) ? TafAction_StartSession.fromJSON(object.startSession) : undefined,
            configureStreamingHubProxy: isSet(object.configureStreamingHubProxy)
                ? TafAction_ConfigureStreamingHubProxy.fromJSON(object.configureStreamingHubProxy)
                : undefined,
            configureVast: isSet(object.configureVast) ? TafAction_ConfigureVast.fromJSON(object.configureVast) : undefined,
            cleanupSession: isSet(object.cleanupSession)
                ? TafAction_CleanupSession.fromJSON(object.cleanupSession)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.sleep !== undefined) {
            obj.sleep = TafAction_Sleep.toJSON(message.sleep);
        }
        if (message.setVariant !== undefined) {
            obj.setVariant = TafAction_SetVariant.toJSON(message.setVariant);
        }
        if (message.setupZapiProxy !== undefined) {
            obj.setupZapiProxy = TafAction_SetupZapiProxy.toJSON(message.setupZapiProxy);
        }
        if (message.setupZapiMockedProxy !== undefined) {
            obj.setupZapiMockedProxy = TafAction_SetupZapiMockedProxy.toJSON(message.setupZapiMockedProxy);
        }
        if (message.configureZapiMockedProxy !== undefined) {
            obj.configureZapiMockedProxy = TafAction_ConfigureZapiMockedProxy.toJSON(message.configureZapiMockedProxy);
        }
        if (message.startSession !== undefined) {
            obj.startSession = TafAction_StartSession.toJSON(message.startSession);
        }
        if (message.configureStreamingHubProxy !== undefined) {
            obj.configureStreamingHubProxy = TafAction_ConfigureStreamingHubProxy.toJSON(message.configureStreamingHubProxy);
        }
        if (message.configureVast !== undefined) {
            obj.configureVast = TafAction_ConfigureVast.toJSON(message.configureVast);
        }
        if (message.cleanupSession !== undefined) {
            obj.cleanupSession = TafAction_CleanupSession.toJSON(message.cleanupSession);
        }
        return obj;
    },
    create(base) {
        return TafAction.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction();
        message.sleep = (object.sleep !== undefined && object.sleep !== null)
            ? TafAction_Sleep.fromPartial(object.sleep)
            : undefined;
        message.setVariant = (object.setVariant !== undefined && object.setVariant !== null)
            ? TafAction_SetVariant.fromPartial(object.setVariant)
            : undefined;
        message.setupZapiProxy = (object.setupZapiProxy !== undefined && object.setupZapiProxy !== null)
            ? TafAction_SetupZapiProxy.fromPartial(object.setupZapiProxy)
            : undefined;
        message.setupZapiMockedProxy = (object.setupZapiMockedProxy !== undefined && object.setupZapiMockedProxy !== null)
            ? TafAction_SetupZapiMockedProxy.fromPartial(object.setupZapiMockedProxy)
            : undefined;
        message.configureZapiMockedProxy =
            (object.configureZapiMockedProxy !== undefined && object.configureZapiMockedProxy !== null)
                ? TafAction_ConfigureZapiMockedProxy.fromPartial(object.configureZapiMockedProxy)
                : undefined;
        message.startSession = (object.startSession !== undefined && object.startSession !== null)
            ? TafAction_StartSession.fromPartial(object.startSession)
            : undefined;
        message.configureStreamingHubProxy =
            (object.configureStreamingHubProxy !== undefined && object.configureStreamingHubProxy !== null)
                ? TafAction_ConfigureStreamingHubProxy.fromPartial(object.configureStreamingHubProxy)
                : undefined;
        message.configureVast = (object.configureVast !== undefined && object.configureVast !== null)
            ? TafAction_ConfigureVast.fromPartial(object.configureVast)
            : undefined;
        message.cleanupSession = (object.cleanupSession !== undefined && object.cleanupSession !== null)
            ? TafAction_CleanupSession.fromPartial(object.cleanupSession)
            : undefined;
        return message;
    },
};
function createBaseTafAction_Sleep() {
    return { ms: 0 };
}
export const TafAction_Sleep = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.ms !== 0) {
            writer.uint32(8).uint32(message.ms);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_Sleep();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.ms = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { ms: isSet(object.ms) ? globalThis.Number(object.ms) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.ms !== 0) {
            obj.ms = Math.round(message.ms);
        }
        return obj;
    },
    create(base) {
        return TafAction_Sleep.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction_Sleep();
        message.ms = object.ms ?? 0;
        return message;
    },
};
function createBaseTafAction_SetVariant() {
    return { variant: 0, nielsenConsumer: undefined };
}
export const TafAction_SetVariant = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.variant !== 0) {
            writer.uint32(8).int32(message.variant);
        }
        if (message.nielsenConsumer !== undefined) {
            writer.uint32(18).string(message.nielsenConsumer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_SetVariant();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.variant = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.nielsenConsumer = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            variant: isSet(object.variant) ? tafAction_SetVariant_VariantFromJSON(object.variant) : 0,
            nielsenConsumer: isSet(object.nielsenConsumer) ? globalThis.String(object.nielsenConsumer) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.variant !== 0) {
            obj.variant = tafAction_SetVariant_VariantToJSON(message.variant);
        }
        if (message.nielsenConsumer !== undefined) {
            obj.nielsenConsumer = message.nielsenConsumer;
        }
        return obj;
    },
    create(base) {
        return TafAction_SetVariant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction_SetVariant();
        message.variant = object.variant ?? 0;
        message.nielsenConsumer = object.nielsenConsumer ?? undefined;
        return message;
    },
};
function createBaseTafAction_SetupZapiProxy() {
    return { host: "" };
}
export const TafAction_SetupZapiProxy = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.host !== "") {
            writer.uint32(10).string(message.host);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_SetupZapiProxy();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.host = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { host: isSet(object.host) ? globalThis.String(object.host) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.host !== "") {
            obj.host = message.host;
        }
        return obj;
    },
    create(base) {
        return TafAction_SetupZapiProxy.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction_SetupZapiProxy();
        message.host = object.host ?? "";
        return message;
    },
};
function createBaseTafAction_SetupZapiMockedProxy() {
    return { streamapiConfig: undefined };
}
export const TafAction_SetupZapiMockedProxy = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.streamapiConfig !== undefined) {
            TafAction_SetupZapiMockedProxy_Config.encode(message.streamapiConfig, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_SetupZapiMockedProxy();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.streamapiConfig = TafAction_SetupZapiMockedProxy_Config.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            streamapiConfig: isSet(object.streamapiConfig)
                ? TafAction_SetupZapiMockedProxy_Config.fromJSON(object.streamapiConfig)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.streamapiConfig !== undefined) {
            obj.streamapiConfig = TafAction_SetupZapiMockedProxy_Config.toJSON(message.streamapiConfig);
        }
        return obj;
    },
    create(base) {
        return TafAction_SetupZapiMockedProxy.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction_SetupZapiMockedProxy();
        message.streamapiConfig = (object.streamapiConfig !== undefined && object.streamapiConfig !== null)
            ? TafAction_SetupZapiMockedProxy_Config.fromPartial(object.streamapiConfig)
            : undefined;
        return message;
    },
};
function createBaseTafAction_SetupZapiMockedProxy_Config() {
    return { url: "", partnerId: "", secret: "" };
}
export const TafAction_SetupZapiMockedProxy_Config = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.url !== "") {
            writer.uint32(10).string(message.url);
        }
        if (message.partnerId !== "") {
            writer.uint32(18).string(message.partnerId);
        }
        if (message.secret !== "") {
            writer.uint32(26).string(message.secret);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_SetupZapiMockedProxy_Config();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.url = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.partnerId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.secret = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            url: isSet(object.url) ? globalThis.String(object.url) : "",
            partnerId: isSet(object.partnerId) ? globalThis.String(object.partnerId) : "",
            secret: isSet(object.secret) ? globalThis.String(object.secret) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.url !== "") {
            obj.url = message.url;
        }
        if (message.partnerId !== "") {
            obj.partnerId = message.partnerId;
        }
        if (message.secret !== "") {
            obj.secret = message.secret;
        }
        return obj;
    },
    create(base) {
        return TafAction_SetupZapiMockedProxy_Config.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction_SetupZapiMockedProxy_Config();
        message.url = object.url ?? "";
        message.partnerId = object.partnerId ?? "";
        message.secret = object.secret ?? "";
        return message;
    },
};
function createBaseTafAction_ConfigureZapiMockedProxy() {
    return { liveConfigs: [], recordingConfigs: [], replayConfigs: [] };
}
export const TafAction_ConfigureZapiMockedProxy = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.liveConfigs) {
            TafAction_ConfigureZapiMockedProxy_LiveConfig.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.recordingConfigs) {
            TafAction_ConfigureZapiMockedProxy_RecordingConfig.encode(v, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.replayConfigs) {
            TafAction_ConfigureZapiMockedProxy_ReplayConfig.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_ConfigureZapiMockedProxy();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.liveConfigs.push(TafAction_ConfigureZapiMockedProxy_LiveConfig.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.recordingConfigs.push(TafAction_ConfigureZapiMockedProxy_RecordingConfig.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.replayConfigs.push(TafAction_ConfigureZapiMockedProxy_ReplayConfig.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            liveConfigs: globalThis.Array.isArray(object?.liveConfigs)
                ? object.liveConfigs.map((e) => TafAction_ConfigureZapiMockedProxy_LiveConfig.fromJSON(e))
                : [],
            recordingConfigs: globalThis.Array.isArray(object?.recordingConfigs)
                ? object.recordingConfigs.map((e) => TafAction_ConfigureZapiMockedProxy_RecordingConfig.fromJSON(e))
                : [],
            replayConfigs: globalThis.Array.isArray(object?.replayConfigs)
                ? object.replayConfigs.map((e) => TafAction_ConfigureZapiMockedProxy_ReplayConfig.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.liveConfigs?.length) {
            obj.liveConfigs = message.liveConfigs.map((e) => TafAction_ConfigureZapiMockedProxy_LiveConfig.toJSON(e));
        }
        if (message.recordingConfigs?.length) {
            obj.recordingConfigs = message.recordingConfigs.map((e) => TafAction_ConfigureZapiMockedProxy_RecordingConfig.toJSON(e));
        }
        if (message.replayConfigs?.length) {
            obj.replayConfigs = message.replayConfigs.map((e) => TafAction_ConfigureZapiMockedProxy_ReplayConfig.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return TafAction_ConfigureZapiMockedProxy.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction_ConfigureZapiMockedProxy();
        message.liveConfigs =
            object.liveConfigs?.map((e) => TafAction_ConfigureZapiMockedProxy_LiveConfig.fromPartial(e)) || [];
        message.recordingConfigs =
            object.recordingConfigs?.map((e) => TafAction_ConfigureZapiMockedProxy_RecordingConfig.fromPartial(e)) || [];
        message.replayConfigs =
            object.replayConfigs?.map((e) => TafAction_ConfigureZapiMockedProxy_ReplayConfig.fromPartial(e)) || [];
        return message;
    },
};
function createBaseTafAction_ConfigureZapiMockedProxy_Stream() {
    return { padding: undefined, ads: [], schedule: [], forwardSeeking: undefined };
}
export const TafAction_ConfigureZapiMockedProxy_Stream = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.padding !== undefined) {
            TafAction_ConfigureZapiMockedProxy_Stream_Padding.encode(message.padding, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.ads) {
            TafAction_ConfigureZapiMockedProxy_Stream_Ad.encode(v, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.schedule) {
            GT12_Schedule.encode(v, writer.uint32(26).fork()).ldelim();
        }
        if (message.forwardSeeking !== undefined) {
            writer.uint32(32).bool(message.forwardSeeking);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_ConfigureZapiMockedProxy_Stream();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.padding = TafAction_ConfigureZapiMockedProxy_Stream_Padding.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.ads.push(TafAction_ConfigureZapiMockedProxy_Stream_Ad.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.schedule.push(GT12_Schedule.decode(reader, reader.uint32()));
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.forwardSeeking = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            padding: isSet(object.padding)
                ? TafAction_ConfigureZapiMockedProxy_Stream_Padding.fromJSON(object.padding)
                : undefined,
            ads: globalThis.Array.isArray(object?.ads)
                ? object.ads.map((e) => TafAction_ConfigureZapiMockedProxy_Stream_Ad.fromJSON(e))
                : [],
            schedule: globalThis.Array.isArray(object?.schedule)
                ? object.schedule.map((e) => GT12_Schedule.fromJSON(e))
                : [],
            forwardSeeking: isSet(object.forwardSeeking) ? globalThis.Boolean(object.forwardSeeking) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.padding !== undefined) {
            obj.padding = TafAction_ConfigureZapiMockedProxy_Stream_Padding.toJSON(message.padding);
        }
        if (message.ads?.length) {
            obj.ads = message.ads.map((e) => TafAction_ConfigureZapiMockedProxy_Stream_Ad.toJSON(e));
        }
        if (message.schedule?.length) {
            obj.schedule = message.schedule.map((e) => GT12_Schedule.toJSON(e));
        }
        if (message.forwardSeeking !== undefined) {
            obj.forwardSeeking = message.forwardSeeking;
        }
        return obj;
    },
    create(base) {
        return TafAction_ConfigureZapiMockedProxy_Stream.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction_ConfigureZapiMockedProxy_Stream();
        message.padding = (object.padding !== undefined && object.padding !== null)
            ? TafAction_ConfigureZapiMockedProxy_Stream_Padding.fromPartial(object.padding)
            : undefined;
        message.ads = object.ads?.map((e) => TafAction_ConfigureZapiMockedProxy_Stream_Ad.fromPartial(e)) || [];
        message.schedule = object.schedule?.map((e) => GT12_Schedule.fromPartial(e)) || [];
        message.forwardSeeking = object.forwardSeeking ?? undefined;
        return message;
    },
};
function createBaseTafAction_ConfigureZapiMockedProxy_Stream_Padding() {
    return { pre: 0, post: 0 };
}
export const TafAction_ConfigureZapiMockedProxy_Stream_Padding = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.pre !== 0) {
            writer.uint32(8).uint32(message.pre);
        }
        if (message.post !== 0) {
            writer.uint32(16).uint32(message.post);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_ConfigureZapiMockedProxy_Stream_Padding();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.pre = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.post = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            pre: isSet(object.pre) ? globalThis.Number(object.pre) : 0,
            post: isSet(object.post) ? globalThis.Number(object.post) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pre !== 0) {
            obj.pre = Math.round(message.pre);
        }
        if (message.post !== 0) {
            obj.post = Math.round(message.post);
        }
        return obj;
    },
    create(base) {
        return TafAction_ConfigureZapiMockedProxy_Stream_Padding.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction_ConfigureZapiMockedProxy_Stream_Padding();
        message.pre = object.pre ?? 0;
        message.post = object.post ?? 0;
        return message;
    },
};
function createBaseTafAction_ConfigureZapiMockedProxy_Stream_Ad() {
    return { isChannelAd: undefined, maxDuration: undefined, offset: undefined, type: 0, vastUrl: "" };
}
export const TafAction_ConfigureZapiMockedProxy_Stream_Ad = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.isChannelAd !== undefined) {
            writer.uint32(8).bool(message.isChannelAd);
        }
        if (message.maxDuration !== undefined) {
            writer.uint32(16).int32(message.maxDuration);
        }
        if (message.offset !== undefined) {
            writer.uint32(24).int32(message.offset);
        }
        if (message.type !== 0) {
            writer.uint32(32).int32(message.type);
        }
        if (message.vastUrl !== "") {
            writer.uint32(42).string(message.vastUrl);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_ConfigureZapiMockedProxy_Stream_Ad();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.isChannelAd = reader.bool();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.maxDuration = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.offset = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.type = reader.int32();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.vastUrl = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            isChannelAd: isSet(object.isChannelAd) ? globalThis.Boolean(object.isChannelAd) : undefined,
            maxDuration: isSet(object.maxDuration) ? globalThis.Number(object.maxDuration) : undefined,
            offset: isSet(object.offset) ? globalThis.Number(object.offset) : undefined,
            type: isSet(object.type) ? tafAction_ConfigureZapiMockedProxy_Stream_Ad_TypeFromJSON(object.type) : 0,
            vastUrl: isSet(object.vastUrl) ? globalThis.String(object.vastUrl) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.isChannelAd !== undefined) {
            obj.isChannelAd = message.isChannelAd;
        }
        if (message.maxDuration !== undefined) {
            obj.maxDuration = Math.round(message.maxDuration);
        }
        if (message.offset !== undefined) {
            obj.offset = Math.round(message.offset);
        }
        if (message.type !== 0) {
            obj.type = tafAction_ConfigureZapiMockedProxy_Stream_Ad_TypeToJSON(message.type);
        }
        if (message.vastUrl !== "") {
            obj.vastUrl = message.vastUrl;
        }
        return obj;
    },
    create(base) {
        return TafAction_ConfigureZapiMockedProxy_Stream_Ad.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction_ConfigureZapiMockedProxy_Stream_Ad();
        message.isChannelAd = object.isChannelAd ?? undefined;
        message.maxDuration = object.maxDuration ?? undefined;
        message.offset = object.offset ?? undefined;
        message.type = object.type ?? 0;
        message.vastUrl = object.vastUrl ?? "";
        return message;
    },
};
function createBaseTafAction_ConfigureZapiMockedProxy_Destination() {
    return {
        channel: "",
        unixStartTime: 0,
        unixEndTime: 0,
        dynamicPvr: false,
        nielsenStationId: undefined,
        nielsenSubBrand: undefined,
    };
}
export const TafAction_ConfigureZapiMockedProxy_Destination = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.channel !== "") {
            writer.uint32(10).string(message.channel);
        }
        if (message.unixStartTime !== 0) {
            writer.uint32(16).int64(message.unixStartTime);
        }
        if (message.unixEndTime !== 0) {
            writer.uint32(24).int64(message.unixEndTime);
        }
        if (message.dynamicPvr !== false) {
            writer.uint32(32).bool(message.dynamicPvr);
        }
        if (message.nielsenStationId !== undefined) {
            writer.uint32(50).string(message.nielsenStationId);
        }
        if (message.nielsenSubBrand !== undefined) {
            writer.uint32(58).string(message.nielsenSubBrand);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_ConfigureZapiMockedProxy_Destination();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.unixStartTime = longToNumber(reader.int64());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.unixEndTime = longToNumber(reader.int64());
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.dynamicPvr = reader.bool();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.nielsenStationId = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.nielsenSubBrand = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel: isSet(object.channel) ? globalThis.String(object.channel) : "",
            unixStartTime: isSet(object.unixStartTime) ? globalThis.Number(object.unixStartTime) : 0,
            unixEndTime: isSet(object.unixEndTime) ? globalThis.Number(object.unixEndTime) : 0,
            dynamicPvr: isSet(object.dynamicPvr) ? globalThis.Boolean(object.dynamicPvr) : false,
            nielsenStationId: isSet(object.nielsenStationId) ? globalThis.String(object.nielsenStationId) : undefined,
            nielsenSubBrand: isSet(object.nielsenSubBrand) ? globalThis.String(object.nielsenSubBrand) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel !== "") {
            obj.channel = message.channel;
        }
        if (message.unixStartTime !== 0) {
            obj.unixStartTime = Math.round(message.unixStartTime);
        }
        if (message.unixEndTime !== 0) {
            obj.unixEndTime = Math.round(message.unixEndTime);
        }
        if (message.dynamicPvr !== false) {
            obj.dynamicPvr = message.dynamicPvr;
        }
        if (message.nielsenStationId !== undefined) {
            obj.nielsenStationId = message.nielsenStationId;
        }
        if (message.nielsenSubBrand !== undefined) {
            obj.nielsenSubBrand = message.nielsenSubBrand;
        }
        return obj;
    },
    create(base) {
        return TafAction_ConfigureZapiMockedProxy_Destination.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction_ConfigureZapiMockedProxy_Destination();
        message.channel = object.channel ?? "";
        message.unixStartTime = object.unixStartTime ?? 0;
        message.unixEndTime = object.unixEndTime ?? 0;
        message.dynamicPvr = object.dynamicPvr ?? false;
        message.nielsenStationId = object.nielsenStationId ?? undefined;
        message.nielsenSubBrand = object.nielsenSubBrand ?? undefined;
        return message;
    },
};
function createBaseTafAction_ConfigureZapiMockedProxy_LiveConfig() {
    return { source: undefined, destination: undefined, timeshiftRegister: undefined, stream: undefined };
}
export const TafAction_ConfigureZapiMockedProxy_LiveConfig = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.source !== undefined) {
            TafAction_ConfigureZapiMockedProxy_LiveConfig_Source.encode(message.source, writer.uint32(10).fork()).ldelim();
        }
        if (message.destination !== undefined) {
            TafAction_ConfigureZapiMockedProxy_LiveConfig_Destination.encode(message.destination, writer.uint32(18).fork())
                .ldelim();
        }
        if (message.timeshiftRegister !== undefined) {
            TafAction_ConfigureZapiMockedProxy_LiveConfig_TimeshiftRegister.encode(message.timeshiftRegister, writer.uint32(26).fork()).ldelim();
        }
        if (message.stream !== undefined) {
            TafAction_ConfigureZapiMockedProxy_Stream.encode(message.stream, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_ConfigureZapiMockedProxy_LiveConfig();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.source = TafAction_ConfigureZapiMockedProxy_LiveConfig_Source.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.destination = TafAction_ConfigureZapiMockedProxy_LiveConfig_Destination.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.timeshiftRegister = TafAction_ConfigureZapiMockedProxy_LiveConfig_TimeshiftRegister.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.stream = TafAction_ConfigureZapiMockedProxy_Stream.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            source: isSet(object.source)
                ? TafAction_ConfigureZapiMockedProxy_LiveConfig_Source.fromJSON(object.source)
                : undefined,
            destination: isSet(object.destination)
                ? TafAction_ConfigureZapiMockedProxy_LiveConfig_Destination.fromJSON(object.destination)
                : undefined,
            timeshiftRegister: isSet(object.timeshiftRegister)
                ? TafAction_ConfigureZapiMockedProxy_LiveConfig_TimeshiftRegister.fromJSON(object.timeshiftRegister)
                : undefined,
            stream: isSet(object.stream) ? TafAction_ConfigureZapiMockedProxy_Stream.fromJSON(object.stream) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.source !== undefined) {
            obj.source = TafAction_ConfigureZapiMockedProxy_LiveConfig_Source.toJSON(message.source);
        }
        if (message.destination !== undefined) {
            obj.destination = TafAction_ConfigureZapiMockedProxy_LiveConfig_Destination.toJSON(message.destination);
        }
        if (message.timeshiftRegister !== undefined) {
            obj.timeshiftRegister = TafAction_ConfigureZapiMockedProxy_LiveConfig_TimeshiftRegister.toJSON(message.timeshiftRegister);
        }
        if (message.stream !== undefined) {
            obj.stream = TafAction_ConfigureZapiMockedProxy_Stream.toJSON(message.stream);
        }
        return obj;
    },
    create(base) {
        return TafAction_ConfigureZapiMockedProxy_LiveConfig.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction_ConfigureZapiMockedProxy_LiveConfig();
        message.source = (object.source !== undefined && object.source !== null)
            ? TafAction_ConfigureZapiMockedProxy_LiveConfig_Source.fromPartial(object.source)
            : undefined;
        message.destination = (object.destination !== undefined && object.destination !== null)
            ? TafAction_ConfigureZapiMockedProxy_LiveConfig_Destination.fromPartial(object.destination)
            : undefined;
        message.timeshiftRegister = (object.timeshiftRegister !== undefined && object.timeshiftRegister !== null)
            ? TafAction_ConfigureZapiMockedProxy_LiveConfig_TimeshiftRegister.fromPartial(object.timeshiftRegister)
            : undefined;
        message.stream = (object.stream !== undefined && object.stream !== null)
            ? TafAction_ConfigureZapiMockedProxy_Stream.fromPartial(object.stream)
            : undefined;
        return message;
    },
};
function createBaseTafAction_ConfigureZapiMockedProxy_LiveConfig_Source() {
    return { cid: "" };
}
export const TafAction_ConfigureZapiMockedProxy_LiveConfig_Source = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.cid !== "") {
            writer.uint32(10).string(message.cid);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_ConfigureZapiMockedProxy_LiveConfig_Source();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.cid = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { cid: isSet(object.cid) ? globalThis.String(object.cid) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.cid !== "") {
            obj.cid = message.cid;
        }
        return obj;
    },
    create(base) {
        return TafAction_ConfigureZapiMockedProxy_LiveConfig_Source.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction_ConfigureZapiMockedProxy_LiveConfig_Source();
        message.cid = object.cid ?? "";
        return message;
    },
};
function createBaseTafAction_ConfigureZapiMockedProxy_LiveConfig_Destination() {
    return {
        cid: "",
        timeshift: 0,
        registerTimeshift: undefined,
        unregisteredTimeshift: undefined,
        replaySeekingAllowed: undefined,
        nielsenStationId: undefined,
        nielsenSubBrand: undefined,
    };
}
export const TafAction_ConfigureZapiMockedProxy_LiveConfig_Destination = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.cid !== "") {
            writer.uint32(10).string(message.cid);
        }
        if (message.timeshift !== 0) {
            writer.uint32(16).int64(message.timeshift);
        }
        if (message.registerTimeshift !== undefined) {
            writer.uint32(24).int32(message.registerTimeshift);
        }
        if (message.unregisteredTimeshift !== undefined) {
            writer.uint32(32).int32(message.unregisteredTimeshift);
        }
        if (message.replaySeekingAllowed !== undefined) {
            writer.uint32(40).bool(message.replaySeekingAllowed);
        }
        if (message.nielsenStationId !== undefined) {
            writer.uint32(50).string(message.nielsenStationId);
        }
        if (message.nielsenSubBrand !== undefined) {
            writer.uint32(58).string(message.nielsenSubBrand);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_ConfigureZapiMockedProxy_LiveConfig_Destination();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.cid = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.timeshift = longToNumber(reader.int64());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.registerTimeshift = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.unregisteredTimeshift = reader.int32();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.replaySeekingAllowed = reader.bool();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.nielsenStationId = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.nielsenSubBrand = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            cid: isSet(object.cid) ? globalThis.String(object.cid) : "",
            timeshift: isSet(object.timeshift) ? globalThis.Number(object.timeshift) : 0,
            registerTimeshift: isSet(object.registerTimeshift)
                ? tafAction_ConfigureZapiMockedProxy_TimeshiftModeFromJSON(object.registerTimeshift)
                : undefined,
            unregisteredTimeshift: isSet(object.unregisteredTimeshift)
                ? tafAction_ConfigureZapiMockedProxy_TimeshiftModeFromJSON(object.unregisteredTimeshift)
                : undefined,
            replaySeekingAllowed: isSet(object.replaySeekingAllowed)
                ? globalThis.Boolean(object.replaySeekingAllowed)
                : undefined,
            nielsenStationId: isSet(object.nielsenStationId) ? globalThis.String(object.nielsenStationId) : undefined,
            nielsenSubBrand: isSet(object.nielsenSubBrand) ? globalThis.String(object.nielsenSubBrand) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.cid !== "") {
            obj.cid = message.cid;
        }
        if (message.timeshift !== 0) {
            obj.timeshift = Math.round(message.timeshift);
        }
        if (message.registerTimeshift !== undefined) {
            obj.registerTimeshift = tafAction_ConfigureZapiMockedProxy_TimeshiftModeToJSON(message.registerTimeshift);
        }
        if (message.unregisteredTimeshift !== undefined) {
            obj.unregisteredTimeshift = tafAction_ConfigureZapiMockedProxy_TimeshiftModeToJSON(message.unregisteredTimeshift);
        }
        if (message.replaySeekingAllowed !== undefined) {
            obj.replaySeekingAllowed = message.replaySeekingAllowed;
        }
        if (message.nielsenStationId !== undefined) {
            obj.nielsenStationId = message.nielsenStationId;
        }
        if (message.nielsenSubBrand !== undefined) {
            obj.nielsenSubBrand = message.nielsenSubBrand;
        }
        return obj;
    },
    create(base) {
        return TafAction_ConfigureZapiMockedProxy_LiveConfig_Destination.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction_ConfigureZapiMockedProxy_LiveConfig_Destination();
        message.cid = object.cid ?? "";
        message.timeshift = object.timeshift ?? 0;
        message.registerTimeshift = object.registerTimeshift ?? undefined;
        message.unregisteredTimeshift = object.unregisteredTimeshift ?? undefined;
        message.replaySeekingAllowed = object.replaySeekingAllowed ?? undefined;
        message.nielsenStationId = object.nielsenStationId ?? undefined;
        message.nielsenSubBrand = object.nielsenSubBrand ?? undefined;
        return message;
    },
};
function createBaseTafAction_ConfigureZapiMockedProxy_LiveConfig_TimeshiftRegister() {
    return { allowedOffset: 0, quality: 0, forwardSeeking: false, registeredAt: 0 };
}
export const TafAction_ConfigureZapiMockedProxy_LiveConfig_TimeshiftRegister = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.allowedOffset !== 0) {
            writer.uint32(8).int64(message.allowedOffset);
        }
        if (message.quality !== 0) {
            writer.uint32(16).int32(message.quality);
        }
        if (message.forwardSeeking !== false) {
            writer.uint32(24).bool(message.forwardSeeking);
        }
        if (message.registeredAt !== 0) {
            writer.uint32(32).int64(message.registeredAt);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_ConfigureZapiMockedProxy_LiveConfig_TimeshiftRegister();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.allowedOffset = longToNumber(reader.int64());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.quality = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.forwardSeeking = reader.bool();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.registeredAt = longToNumber(reader.int64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            allowedOffset: isSet(object.allowedOffset) ? globalThis.Number(object.allowedOffset) : 0,
            quality: isSet(object.quality) ? tafAction_ConfigureZapiMockedProxy_QualityFromJSON(object.quality) : 0,
            forwardSeeking: isSet(object.forwardSeeking) ? globalThis.Boolean(object.forwardSeeking) : false,
            registeredAt: isSet(object.registeredAt) ? globalThis.Number(object.registeredAt) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.allowedOffset !== 0) {
            obj.allowedOffset = Math.round(message.allowedOffset);
        }
        if (message.quality !== 0) {
            obj.quality = tafAction_ConfigureZapiMockedProxy_QualityToJSON(message.quality);
        }
        if (message.forwardSeeking !== false) {
            obj.forwardSeeking = message.forwardSeeking;
        }
        if (message.registeredAt !== 0) {
            obj.registeredAt = Math.round(message.registeredAt);
        }
        return obj;
    },
    create(base) {
        return TafAction_ConfigureZapiMockedProxy_LiveConfig_TimeshiftRegister.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction_ConfigureZapiMockedProxy_LiveConfig_TimeshiftRegister();
        message.allowedOffset = object.allowedOffset ?? 0;
        message.quality = object.quality ?? 0;
        message.forwardSeeking = object.forwardSeeking ?? false;
        message.registeredAt = object.registeredAt ?? 0;
        return message;
    },
};
function createBaseTafAction_ConfigureZapiMockedProxy_RecordingConfig() {
    return {
        source: undefined,
        destination: undefined,
        stream: undefined,
        nielsenStationId: undefined,
        nielsenSubBrand: undefined,
    };
}
export const TafAction_ConfigureZapiMockedProxy_RecordingConfig = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.source !== undefined) {
            TafAction_ConfigureZapiMockedProxy_RecordingConfig_Source.encode(message.source, writer.uint32(10).fork())
                .ldelim();
        }
        if (message.destination !== undefined) {
            TafAction_ConfigureZapiMockedProxy_Destination.encode(message.destination, writer.uint32(18).fork()).ldelim();
        }
        if (message.stream !== undefined) {
            TafAction_ConfigureZapiMockedProxy_Stream.encode(message.stream, writer.uint32(26).fork()).ldelim();
        }
        if (message.nielsenStationId !== undefined) {
            writer.uint32(50).string(message.nielsenStationId);
        }
        if (message.nielsenSubBrand !== undefined) {
            writer.uint32(58).string(message.nielsenSubBrand);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_ConfigureZapiMockedProxy_RecordingConfig();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.source = TafAction_ConfigureZapiMockedProxy_RecordingConfig_Source.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.destination = TafAction_ConfigureZapiMockedProxy_Destination.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.stream = TafAction_ConfigureZapiMockedProxy_Stream.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.nielsenStationId = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.nielsenSubBrand = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            source: isSet(object.source)
                ? TafAction_ConfigureZapiMockedProxy_RecordingConfig_Source.fromJSON(object.source)
                : undefined,
            destination: isSet(object.destination)
                ? TafAction_ConfigureZapiMockedProxy_Destination.fromJSON(object.destination)
                : undefined,
            stream: isSet(object.stream) ? TafAction_ConfigureZapiMockedProxy_Stream.fromJSON(object.stream) : undefined,
            nielsenStationId: isSet(object.nielsenStationId) ? globalThis.String(object.nielsenStationId) : undefined,
            nielsenSubBrand: isSet(object.nielsenSubBrand) ? globalThis.String(object.nielsenSubBrand) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.source !== undefined) {
            obj.source = TafAction_ConfigureZapiMockedProxy_RecordingConfig_Source.toJSON(message.source);
        }
        if (message.destination !== undefined) {
            obj.destination = TafAction_ConfigureZapiMockedProxy_Destination.toJSON(message.destination);
        }
        if (message.stream !== undefined) {
            obj.stream = TafAction_ConfigureZapiMockedProxy_Stream.toJSON(message.stream);
        }
        if (message.nielsenStationId !== undefined) {
            obj.nielsenStationId = message.nielsenStationId;
        }
        if (message.nielsenSubBrand !== undefined) {
            obj.nielsenSubBrand = message.nielsenSubBrand;
        }
        return obj;
    },
    create(base) {
        return TafAction_ConfigureZapiMockedProxy_RecordingConfig.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction_ConfigureZapiMockedProxy_RecordingConfig();
        message.source = (object.source !== undefined && object.source !== null)
            ? TafAction_ConfigureZapiMockedProxy_RecordingConfig_Source.fromPartial(object.source)
            : undefined;
        message.destination = (object.destination !== undefined && object.destination !== null)
            ? TafAction_ConfigureZapiMockedProxy_Destination.fromPartial(object.destination)
            : undefined;
        message.stream = (object.stream !== undefined && object.stream !== null)
            ? TafAction_ConfigureZapiMockedProxy_Stream.fromPartial(object.stream)
            : undefined;
        message.nielsenStationId = object.nielsenStationId ?? undefined;
        message.nielsenSubBrand = object.nielsenSubBrand ?? undefined;
        return message;
    },
};
function createBaseTafAction_ConfigureZapiMockedProxy_RecordingConfig_Source() {
    return { recordingId: 0 };
}
export const TafAction_ConfigureZapiMockedProxy_RecordingConfig_Source = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.recordingId !== 0) {
            writer.uint32(8).uint32(message.recordingId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_ConfigureZapiMockedProxy_RecordingConfig_Source();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.recordingId = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { recordingId: isSet(object.recordingId) ? globalThis.Number(object.recordingId) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.recordingId !== 0) {
            obj.recordingId = Math.round(message.recordingId);
        }
        return obj;
    },
    create(base) {
        return TafAction_ConfigureZapiMockedProxy_RecordingConfig_Source.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction_ConfigureZapiMockedProxy_RecordingConfig_Source();
        message.recordingId = object.recordingId ?? 0;
        return message;
    },
};
function createBaseTafAction_ConfigureZapiMockedProxy_ReplayConfig() {
    return { source: undefined, destination: undefined, stream: undefined };
}
export const TafAction_ConfigureZapiMockedProxy_ReplayConfig = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.source !== undefined) {
            TafAction_ConfigureZapiMockedProxy_ReplayConfig_Source.encode(message.source, writer.uint32(10).fork()).ldelim();
        }
        if (message.destination !== undefined) {
            TafAction_ConfigureZapiMockedProxy_Destination.encode(message.destination, writer.uint32(18).fork()).ldelim();
        }
        if (message.stream !== undefined) {
            TafAction_ConfigureZapiMockedProxy_Stream.encode(message.stream, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_ConfigureZapiMockedProxy_ReplayConfig();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.source = TafAction_ConfigureZapiMockedProxy_ReplayConfig_Source.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.destination = TafAction_ConfigureZapiMockedProxy_Destination.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.stream = TafAction_ConfigureZapiMockedProxy_Stream.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            source: isSet(object.source)
                ? TafAction_ConfigureZapiMockedProxy_ReplayConfig_Source.fromJSON(object.source)
                : undefined,
            destination: isSet(object.destination)
                ? TafAction_ConfigureZapiMockedProxy_Destination.fromJSON(object.destination)
                : undefined,
            stream: isSet(object.stream) ? TafAction_ConfigureZapiMockedProxy_Stream.fromJSON(object.stream) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.source !== undefined) {
            obj.source = TafAction_ConfigureZapiMockedProxy_ReplayConfig_Source.toJSON(message.source);
        }
        if (message.destination !== undefined) {
            obj.destination = TafAction_ConfigureZapiMockedProxy_Destination.toJSON(message.destination);
        }
        if (message.stream !== undefined) {
            obj.stream = TafAction_ConfigureZapiMockedProxy_Stream.toJSON(message.stream);
        }
        return obj;
    },
    create(base) {
        return TafAction_ConfigureZapiMockedProxy_ReplayConfig.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction_ConfigureZapiMockedProxy_ReplayConfig();
        message.source = (object.source !== undefined && object.source !== null)
            ? TafAction_ConfigureZapiMockedProxy_ReplayConfig_Source.fromPartial(object.source)
            : undefined;
        message.destination = (object.destination !== undefined && object.destination !== null)
            ? TafAction_ConfigureZapiMockedProxy_Destination.fromPartial(object.destination)
            : undefined;
        message.stream = (object.stream !== undefined && object.stream !== null)
            ? TafAction_ConfigureZapiMockedProxy_Stream.fromPartial(object.stream)
            : undefined;
        return message;
    },
};
function createBaseTafAction_ConfigureZapiMockedProxy_ReplayConfig_Source() {
    return { cid: "", programId: 0 };
}
export const TafAction_ConfigureZapiMockedProxy_ReplayConfig_Source = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.cid !== "") {
            writer.uint32(10).string(message.cid);
        }
        if (message.programId !== 0) {
            writer.uint32(16).uint32(message.programId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_ConfigureZapiMockedProxy_ReplayConfig_Source();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.cid = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.programId = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            cid: isSet(object.cid) ? globalThis.String(object.cid) : "",
            programId: isSet(object.programId) ? globalThis.Number(object.programId) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.cid !== "") {
            obj.cid = message.cid;
        }
        if (message.programId !== 0) {
            obj.programId = Math.round(message.programId);
        }
        return obj;
    },
    create(base) {
        return TafAction_ConfigureZapiMockedProxy_ReplayConfig_Source.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction_ConfigureZapiMockedProxy_ReplayConfig_Source();
        message.cid = object.cid ?? "";
        message.programId = object.programId ?? 0;
        return message;
    },
};
function createBaseTafAction_StartSession() {
    return { name: "" };
}
export const TafAction_StartSession = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_StartSession();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { name: isSet(object.name) ? globalThis.String(object.name) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        return obj;
    },
    create(base) {
        return TafAction_StartSession.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction_StartSession();
        message.name = object.name ?? "";
        return message;
    },
};
function createBaseTafAction_ConfigureStreamingHubProxy() {
    return { license: undefined };
}
export const TafAction_ConfigureStreamingHubProxy = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.license !== undefined) {
            TafAction_ConfigureStreamingHubProxy_License.encode(message.license, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_ConfigureStreamingHubProxy();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.license = TafAction_ConfigureStreamingHubProxy_License.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            license: isSet(object.license)
                ? TafAction_ConfigureStreamingHubProxy_License.fromJSON(object.license)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.license !== undefined) {
            obj.license = TafAction_ConfigureStreamingHubProxy_License.toJSON(message.license);
        }
        return obj;
    },
    create(base) {
        return TafAction_ConfigureStreamingHubProxy.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction_ConfigureStreamingHubProxy();
        message.license = (object.license !== undefined && object.license !== null)
            ? TafAction_ConfigureStreamingHubProxy_License.fromPartial(object.license)
            : undefined;
        return message;
    },
};
function createBaseTafAction_ConfigureStreamingHubProxy_License() {
    return { valid: undefined, invalid: undefined };
}
export const TafAction_ConfigureStreamingHubProxy_License = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.valid !== undefined) {
            TafAction_ConfigureStreamingHubProxy_License_Valid.encode(message.valid, writer.uint32(10).fork()).ldelim();
        }
        if (message.invalid !== undefined) {
            TafAction_ConfigureStreamingHubProxy_License_Invalid.encode(message.invalid, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_ConfigureStreamingHubProxy_License();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.valid = TafAction_ConfigureStreamingHubProxy_License_Valid.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.invalid = TafAction_ConfigureStreamingHubProxy_License_Invalid.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            valid: isSet(object.valid)
                ? TafAction_ConfigureStreamingHubProxy_License_Valid.fromJSON(object.valid)
                : undefined,
            invalid: isSet(object.invalid)
                ? TafAction_ConfigureStreamingHubProxy_License_Invalid.fromJSON(object.invalid)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.valid !== undefined) {
            obj.valid = TafAction_ConfigureStreamingHubProxy_License_Valid.toJSON(message.valid);
        }
        if (message.invalid !== undefined) {
            obj.invalid = TafAction_ConfigureStreamingHubProxy_License_Invalid.toJSON(message.invalid);
        }
        return obj;
    },
    create(base) {
        return TafAction_ConfigureStreamingHubProxy_License.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction_ConfigureStreamingHubProxy_License();
        message.valid = (object.valid !== undefined && object.valid !== null)
            ? TafAction_ConfigureStreamingHubProxy_License_Valid.fromPartial(object.valid)
            : undefined;
        message.invalid = (object.invalid !== undefined && object.invalid !== null)
            ? TafAction_ConfigureStreamingHubProxy_License_Invalid.fromPartial(object.invalid)
            : undefined;
        return message;
    },
};
function createBaseTafAction_ConfigureStreamingHubProxy_License_Valid() {
    return { scope: [] };
}
export const TafAction_ConfigureStreamingHubProxy_License_Valid = {
    encode(message, writer = _m0.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.scope) {
            writer.int32(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_ConfigureStreamingHubProxy_License_Valid();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag === 8) {
                        message.scope.push(reader.int32());
                        continue;
                    }
                    if (tag === 10) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.scope.push(reader.int32());
                        }
                        continue;
                    }
                    break;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            scope: globalThis.Array.isArray(object?.scope)
                ? object.scope.map((e) => tafAction_ConfigureStreamingHubProxy_License_Valid_ScopeFromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.scope?.length) {
            obj.scope = message.scope.map((e) => tafAction_ConfigureStreamingHubProxy_License_Valid_ScopeToJSON(e));
        }
        return obj;
    },
    create(base) {
        return TafAction_ConfigureStreamingHubProxy_License_Valid.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction_ConfigureStreamingHubProxy_License_Valid();
        message.scope = object.scope?.map((e) => e) || [];
        return message;
    },
};
function createBaseTafAction_ConfigureStreamingHubProxy_License_Invalid() {
    return {};
}
export const TafAction_ConfigureStreamingHubProxy_License_Invalid = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_ConfigureStreamingHubProxy_License_Invalid();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return TafAction_ConfigureStreamingHubProxy_License_Invalid.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseTafAction_ConfigureStreamingHubProxy_License_Invalid();
        return message;
    },
};
function createBaseTafAction_ConfigureVast() {
    return { vast: {}, playlist: {}, source: 0 };
}
export const TafAction_ConfigureVast = {
    encode(message, writer = _m0.Writer.create()) {
        Object.entries(message.vast).forEach(([key, value]) => {
            TafAction_ConfigureVast_VastEntry.encode({ key: key, value }, writer.uint32(10).fork()).ldelim();
        });
        Object.entries(message.playlist).forEach(([key, value]) => {
            TafAction_ConfigureVast_PlaylistEntry.encode({ key: key, value }, writer.uint32(18).fork()).ldelim();
        });
        if (message.source !== 0) {
            writer.uint32(24).int32(message.source);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_ConfigureVast();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    const entry1 = TafAction_ConfigureVast_VastEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.vast[entry1.key] = entry1.value;
                    }
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    const entry2 = TafAction_ConfigureVast_PlaylistEntry.decode(reader, reader.uint32());
                    if (entry2.value !== undefined) {
                        message.playlist[entry2.key] = entry2.value;
                    }
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.source = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            vast: isObject(object.vast)
                ? Object.entries(object.vast).reduce((acc, [key, value]) => {
                    acc[key] = VastAds.fromJSON(value);
                    return acc;
                }, {})
                : {},
            playlist: isObject(object.playlist)
                ? Object.entries(object.playlist).reduce((acc, [key, value]) => {
                    acc[key] = VastPlaylist.fromJSON(value);
                    return acc;
                }, {})
                : {},
            source: isSet(object.source) ? tafAction_ConfigureVast_SourceFromJSON(object.source) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.vast) {
            const entries = Object.entries(message.vast);
            if (entries.length > 0) {
                obj.vast = {};
                entries.forEach(([k, v]) => {
                    obj.vast[k] = VastAds.toJSON(v);
                });
            }
        }
        if (message.playlist) {
            const entries = Object.entries(message.playlist);
            if (entries.length > 0) {
                obj.playlist = {};
                entries.forEach(([k, v]) => {
                    obj.playlist[k] = VastPlaylist.toJSON(v);
                });
            }
        }
        if (message.source !== 0) {
            obj.source = tafAction_ConfigureVast_SourceToJSON(message.source);
        }
        return obj;
    },
    create(base) {
        return TafAction_ConfigureVast.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction_ConfigureVast();
        message.vast = Object.entries(object.vast ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = VastAds.fromPartial(value);
            }
            return acc;
        }, {});
        message.playlist = Object.entries(object.playlist ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = VastPlaylist.fromPartial(value);
            }
            return acc;
        }, {});
        message.source = object.source ?? 0;
        return message;
    },
};
function createBaseTafAction_ConfigureVast_VastEntry() {
    return { key: "", value: undefined };
}
export const TafAction_ConfigureVast_VastEntry = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            VastAds.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_ConfigureVast_VastEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = VastAds.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? VastAds.fromJSON(object.value) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = VastAds.toJSON(message.value);
        }
        return obj;
    },
    create(base) {
        return TafAction_ConfigureVast_VastEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction_ConfigureVast_VastEntry();
        message.key = object.key ?? "";
        message.value = (object.value !== undefined && object.value !== null)
            ? VastAds.fromPartial(object.value)
            : undefined;
        return message;
    },
};
function createBaseTafAction_ConfigureVast_PlaylistEntry() {
    return { key: "", value: undefined };
}
export const TafAction_ConfigureVast_PlaylistEntry = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            VastPlaylist.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_ConfigureVast_PlaylistEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = VastPlaylist.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? VastPlaylist.fromJSON(object.value) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = VastPlaylist.toJSON(message.value);
        }
        return obj;
    },
    create(base) {
        return TafAction_ConfigureVast_PlaylistEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTafAction_ConfigureVast_PlaylistEntry();
        message.key = object.key ?? "";
        message.value = (object.value !== undefined && object.value !== null)
            ? VastPlaylist.fromPartial(object.value)
            : undefined;
        return message;
    },
};
function createBaseTafAction_CleanupSession() {
    return {};
}
export const TafAction_CleanupSession = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTafAction_CleanupSession();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return TafAction_CleanupSession.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseTafAction_CleanupSession();
        return message;
    },
};
function longToNumber(long) {
    if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
    }
    return long.toNumber();
}
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
function isObject(value) {
    return typeof value === "object" && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
